export default __webpack_public_path__ + "static/media/DISTRIBUCION_DASHBOARD_IMG.36457644.png";